/**
 * <PhoneNumber
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './PhoneNumberInput.scss';
import { getCountryCodes, getCountryCodeByISO, getCountryISO } from 'util/countryCode';

import './vendor/flags16.scss';
import isEmpty from 'lodash/isEmpty';

const DEFAULT_COUNTRY = 'ca'; // CA for Canada for now

export function validatePhone(value) {
  if(value.length > 1 && (value.length < 6) ){
    return {
      ok: false,
      failed: {
        because: ['invalid_phone'],
        value,
      }
    }
  }
}

class PhoneNumberInput extends React.Component {
  constructor(props) {
    super(props);

    this.countryCodes = getCountryCodes();

    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.onChangeNumber = this.onChangeNumber.bind(this);
    this.toggleCountrySelect = this.toggleCountrySelect.bind(this);

    this.state = {
      country: getCountryCodeByISO(props.defaultCountry || DEFAULT_COUNTRY),
    }
  }

  componentWillReceiveProps(nextProps){
    if(!isEmpty(nextProps.value) && typeof(nextProps.value) == 'object'){
      if(nextProps.value.region_code && this.state.country.iso == nextProps.value.region_code.toLowerCase()){
        return
      }
      let country = !nextProps.value.region_code? getCountryISO(nextProps.value.country_code): getCountryCodeByISO(nextProps.value.region_code.toLowerCase())
      this.setState({country})
    }
  }

  convertNumber(value = {}) {
    const {
      country_code = '',
      national_number = '',
    } = value

    return '+' + country_code + ' ' + national_number;
  }

  toggleCountrySelect(isOn) {
    this.setState({
      selectCountry: typeof isOn !== 'undefined' ? isOn : this.selectCountry !== true,
    });
  }

  onChangeCountry(country) {
    return ()=>{
      this.setState({ country });
      this.toggleCountrySelect(false);
      this.props.onChange({
        national_number: '',
        country_code: country.code,
        region_code: country.iso
      });

      this.inputRef.focus();
    }
  }

  onChangeNumber(e) {
    const value = e.target.value || "";

    return this.formatChangeNumber(value);
  }

  formatChangeNumber(value) {
    const {
      code,
      iso
    } = this.state.country;

    this.props.onChange({
      national_number: value.replace("+" + code, '').replace(/[^0-9]/g, '').trim(),
      country_code: code.trim(),
      region_code: iso
    });
  }

  render() {
    let {
      onChange,
      value = {},
      placeholder,
    } = this.props;

    let {
      country,
      selectCountry,
    } = this.state;
 
    return (
      <div className='PhoneNumberInput'>
        <input
          placeholder={placeholder}
          className='form-control phone-number'
          onChange={this.onChangeNumber}
          value={this.convertNumber(value)}
          onFocus={()=>{this.toggleCountrySelect(false)}}
          onBlur={()=>{this.toggleCountrySelect(false)}}
          ref={(r)=>{this.inputRef = r;}}
        />
        <div className='PhoneNumberInput--holder f16' onClick={this.toggleCountrySelect}>
          <div className={classnames('PhoneNumberInput--flag flag 0', country.iso)}></div>
          <i className='fa icon-down-dir'></i>
        </div>
        <div className={classnames('PhoneNumberInput--country-list', { selectCountry })}>
          <ul>
            {this.countryCodes.map((c, index)=>{
              return (<li key={index} className='f16' onClick={this.onChangeCountry(c)}>
                  <div className={classnames('PhoneNumberInput--flag flag 1', c.iso)}></div>
                  <div className='name'>{c.name}</div>
                  <div className='code'>+{c.code}</div>
                </li>);
            })}
          </ul>
        </div>
      </div>
    )
  }
}

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/PhoneNumber/index.js